import { ComponentEvents } from 'global/interfaces/component.interface';

/**
 * Name of the event (Must be unique)
 */
export const MoleculeSearchFieldEvents: ComponentEvents = {
	search: 'searchEvent',
};

/**
 * Data send through the event
 */
export interface MoleculeSearchFieldEvent {
	searchValue: string;
}
